// extracted by mini-css-extract-plugin
module.exports = {"header":"hopper-ui_header__d7Qmu","tabs":"hopper-ui_tabs__194cV","content":"hopper-ui_content__NU2-t"};